<template>
  <div>
    <div v-if="carregando == true" class="carregando">
      <img width="130px" :src="iconeCarregando" />
      <br />
      <br />Carregando...
    </div>
    <div :class="`${insideBox ? '' : 'container'}`">
      <form
        v-if="isLogin"
        ref="form"
        role="form"
        @submit.stop.prevent="onSubmit"
      >
        <div v-if="!insideBox" class=" mb-2">
          <h3>Acesse sua conta</h3>
        </div>
        <div id="inputs " class="form-transparent ">
          <div class="row">
            <div class="col-sm-12 col-lg-12 mt-2">
              <fg-input
                type="email"
                name="Email"
                v-model="form.email"
                label="Email"
                :state="validateState('Email')"
                :class="validateClass('Email')"
                v-validate="{ required: true, email: true }"
              ></fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12 col-lg-12 mt-2">
              <fg-input
                type="password"
                name="Senha"
                label="Senha"
                v-model="form.senha"
                v-validate="{ required: true }"
                :state="validateState('Senha')"
                :class="validateClass('Senha')"
              />
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-sm-12 col-lg-12">
              <n-button
                nativeType="submit"
                class="btn-block   btn-primario-formulario"
                type="success"
                >Entrar</n-button
              >

              <errosAlert
                :exibeErro="exibeErro"
                :msgErro="msgErro"
                :listaErro="$validator.errors.all()"
              ></errosAlert>
            </div>
          </div>

          <div class="row">
            <div class="col-6 col-sm-6 col-lg-6 mt-2">
              <router-link
                v-if="!insideBox"
                class=""
                style="text-decoration:underline"
                :to="returnLink('/Cadastro')"
                >Não tenho Conta</router-link
              >
              <a
                v-else
                class=""
                style="text-decoration:underline"
                @click="open('cadastro')"
                href="javascript:void(0)"
                >Não tenho Conta</a
              >
            </div>
            <div class="col-6 col-sm-6 col-lg-6 mt-2 text-right">
              <router-link
                v-if="!insideBox"
                class=""
                style="text-decoration:underline"
                :to="returnLink('/EsqueciASenha')"
                >Esqueci a Senha</router-link
              >
              <a
                v-else
                class=""
                style="text-decoration:underline"
                @click="open('recupera')"
                href="javascript:void(0)"
                >Esqueci a Senha</a
              >
            </div>
          </div>
        </div>
      </form>
      <formRecupera
        v-if="isRecupera"
        :insideLogin="true"
        @returnLogin="open('login')"
      ></formRecupera>
      <formCadastro
        v-if="isCadastro"
        :insideLogin="true"
        @returnLogin="open('login')"
        @CadastroConcluido="finalizaLogin"
      ></formCadastro>
    </div>
  </div>
</template>
<script>
import {
  Button,
  Checkbox,
  Radio,
  FormGroupInput,
  Slider,
  Switch,
  Alert,
  Modal,
} from '@/components';

import { Popover, DatePicker } from 'element-ui';

import Password from 'vue-password-strength-meter';
import storage from './../../services/storage';
import service from './../../services';

import errosAlert from './errosAlert';
import swal from 'sweetalert';

import locale from './../../locale';
import { KEY_LOCAL_STORAGE } from './../../const';
import formCadastro from './formCadastro.vue';
import formRecupera from './formEsqueciSenha.vue';

export default {
  components: {
    Password,
    errosAlert,
    Alert,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [Radio.name]: Radio,
    [FormGroupInput.name]: FormGroupInput,
    [Switch.name]: Switch,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Popover.name]: Popover,
    Slider,
    Modal,
    formCadastro,
    formRecupera,
  },
  props: ['dados', 'insideBox'],
  data() {
    return {
      isLogin: true,
      isCadastro: false,
      isRecupera: false,
      iconeCarregando: service.getEnvIconeCarregando(),
      score: 0,
      codPerfilAux: null,
      showModal: false,
      showModal2: false,
      carregando: false,
      especialidades: [],
      exibeErro: false,
      msgErro: '',
      isUpdate: false,
      redirect: this.$route.query.redirect,
      form: {
        email: null,
        senha: null,
      },
      radios: {
        radioOn: '2',
        radioOff: '2',
      },
      checkboxes: [],
      switches: {
        defaultOn: true,
        defaultOff: false,
      },
      sliders: {
        simple: 30,
        rangeSlider: [20, 60],
      },
    };
  },
  methods: {
    open(foco) {
      this.isLogin = false;
      this.isCadastro = false;
      this.isRecupera = false;
      if (foco == 'cadastro') this.isCadastro = true;
      if (foco == 'recupera') this.isRecupera = true;
      if (foco == 'login') this.isLogin = true;
    },
    desativar() {
      this.showModal = true;
    },
    reativar() {
      this.showModal2 = true;
    },
    showFeedback({ suggestions, warning }) {
      console.log('🙏', suggestions);
      console.log('⚠', warning);
    },
    showScore(score) {
      this.score = score;
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (this.veeFields[ref]) {
        if (this.veeFields[ref].dirty) {
          if (this.veeFields[ref].valid == false) {
            return 'has-danger';
          } else {
            return 'has-success';
          }
        }
      }
      return null;
    },
    resetForm() {
      return new Promise(resolve => {
        this.form = {
          email: null,
          senha: null,
        };
        this.$nextTick(() => this.$validator.reset());
        resolve();
      });
    },
    onSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.carregando = true;

          this.form.codPerfil = this.codPerfil;

          service
            .post('Login', 'Autenticar', this.form)
            .then(res => {
              this.carregando = false;
              this.exibeErro = false;
              storage.escreveStorage(
                KEY_LOCAL_STORAGE.USER_TOKEN,
                res.data.token,
              );
              storage.escreveStorage(KEY_LOCAL_STORAGE.SALDO, res.data.s);
              storage.escreveStorage(
                KEY_LOCAL_STORAGE.QUANT_ITENS,
                res.data.qtdItens,
              );
              if (this.insideBox == true) {
                this.finalizaLogin('login');
                //this.$router.go(0)
              } else {
                this.goToDashboard();
              }
            })
            .catch(error => {
              console.error(error);
              this.exibeErro = true;
              this.msgErro = 'Não foi possível Entrar, ' + error;
              this.carregando = false;
              swal('ops!', this.msgErro, 'error');
            });
        }
      });
    },
    goToDashboard() {
      const url = this.redirect ? this.redirect : 'dashboard';
      this.$router.push(`/${url}`);
    },
    finalizaLogin(from) {
      this.$emit('login', from);
    },
    changeLocalStorage(key, value) {
      if (key == KEY_LOCAL_STORAGE.USER_TOKEN && value) {
        if (!this.insideBox) this.goToDashboard();
      }
    },
    returnLink(link) {
      return (
        link + `${this.insideBox ? '?retorno=' + this.$route.params.caixa : ''}`
      );
    },
  },
  mounted() {
    this.$validator.localize('ptBr', locale);
    // storage.subscribe(this.changeLocalStorage);
  },
};
</script>

<style scoped>
select {
  padding: 10px !important;
}
input[type='radio'],
input[type='checkbox'] {
  margin-right: 10px !important;
}
.btnbuscar {
  font-size: 24px;
  text-transform: uppercase;
  color: #094049;
}
</style>
<style>
.cardCadastro .form-check .form-check-sign::after {
  color: #fff;
}
</style>
